import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "c-safe-area-bottom",
    style: _normalizeStyle($props.areaStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass(["c-safe-area-bottom-wrap one_card_bg", [$props.areaClass]])
  }, [_renderSlot(_ctx.$slots, "default")], 2)], 4);
}